// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"696":"29046ad685444e73","1324":"773f208bbd3fbdcb","2888":"14398a028b0544f7"}[chunkId] + ".css";
};